import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const advisorClientLinkStatuses = ['none', 'pending', 'accepted'] as const
export const AdvisorClientLinkStatusEnumSchema = z.enum(advisorClientLinkStatuses, { errorMap })
export type AdvisorClientLinkStatusEnum = z.output<typeof AdvisorClientLinkStatusEnumSchema>
